// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__34IuZ","name":"ConsentHeader_name__1PuXq","birthday":"ConsentHeader_birthday__1Mw9M","skeleton":"ConsentHeader_skeleton__3nsjX"};